// This file is auto-generated by scripts/generateApiTypes.ts. Do not edit manually.

export const dmsmOperations = {
  startForecastSpend: ['get', '/batch-jobs-on-demand/forecast-spend'] as const,
  refreshSupplierMasterSpend: [
    'get',
    '/batch-jobs-on-demand/supplier-master-spend'
  ] as const,
  startSupplierSpendAlerts: [
    'get',
    '/batch-jobs-on-demand/supplier-spend-shift-alerts'
  ] as const,
  deleteComment: ['delete', '/comments/{commentId}'] as const,
  findCommentByCommentId: ['get', '/comments/{commentId}'] as const,
  updateComment: ['put', '/comments/{commentId}'] as const,
  getScope: ['get', '/dmsm/master/scope'] as const,
  getScopeOrUnits: ['get', '/dmsm/scope'] as const,
  getFinWebHealth: ['get', '/health'] as const,
  deleteLink: ['delete', '/links/{linkId}'] as const,
  findLinkByLinkId: ['get', '/links/{linkId}'] as const,
  editLink: ['put', '/links/{linkId}'] as const,
  findMasterMGCs: ['get', '/master/mgcs'] as const,
  createNewStrategy: ['post', '/strategies'] as const,
  bulkStrategyUpdate: ['patch', '/strategies/bulk'] as const,
  getDmsmScorecardData: ['post', '/strategies/dmsm-scorecard'] as const,
  findStrategyById: ['get', '/strategies/new/{strategyId}'] as const,
  patchStrategy: ['patch', '/strategies/new/{strategyId}'] as const,
  getStrategiesByMgcUnitCodePair: [
    'post',
    '/strategies/search-by-mgc-unit-code-pair'
  ] as const,
  getAllStrategicSuppliers: ['post', '/strategies/search-suppliers'] as const,
  searchV2: ['post', '/strategies/search/v2'] as const,
  searchMinimalOnly: ['post', '/strategies/searchMinimal'] as const,
  getStrategicSuppliersForUnit: [
    'post',
    '/strategies/strategic-suppliers-for-unit'
  ] as const,
  findStrategyByIdNew: ['get', '/strategies/{strategyId}'] as const,
  editStrategyPUT: ['put', '/strategies/{strategyId}'] as const,
  findAllAttachmentsByStrategyId: [
    'get',
    '/strategies/{strategyId}/attachments'
  ] as const,
  createNewAttachment: [
    'post',
    '/strategies/{strategyId}/attachments'
  ] as const,
  addAttachments: [
    'post',
    '/strategies/{strategyId}/attachments/bulk'
  ] as const,
  deleteAttachment: [
    'delete',
    '/strategies/{strategyId}/attachments/{attachmentId}'
  ] as const,
  fetchAttachmentByAttachmentId: [
    'get',
    '/strategies/{strategyId}/attachments/{attachmentId}'
  ] as const,
  editAttachment: [
    'put',
    '/strategies/{strategyId}/attachments/{attachmentId}'
  ] as const,
  findAllCommentsByStrategyId: [
    'get',
    '/strategies/{strategyId}/comments'
  ] as const,
  createNewComment: ['post', '/strategies/{strategyId}/comments'] as const,
  findCompletionDateById: [
    'get',
    '/strategies/{strategyId}/completionDates'
  ] as const,
  bulkAddUpdate: [
    'post',
    '/strategies/{strategyId}/completionDates/bulk'
  ] as const,
  findAllLinksByStrategyId: ['get', '/strategies/{strategyId}/links'] as const,
  createLink: ['post', '/strategies/{strategyId}/links'] as const,
  getNextThreeYearForecastedSpend: [
    'get',
    '/strategies/{strategyId}/sep-forecast-spend'
  ] as const,
  getCiProjectSpendShift: ['post', '/supplier/ci-project-spend-shift'] as const,
  getAllJdsnGroups: ['get', '/supplier/jdsn-groups'] as const,
  getSupplierSpendShift: ['post', '/supplier/supplier-spend-shift'] as const,
  getSupplierSpendShiftPartDetail: [
    'post',
    '/supplier/supplier-spend-shift/part-detail'
  ] as const,
  getAllTemplates: ['get', '/templates'] as const,
  createTemplate: ['post', '/templates'] as const,
  deleteTemplate: ['delete', '/templates/{id}'] as const,
  getTemplateById: ['get', '/templates/{id}'] as const,
  updateTemplate: ['put', '/templates/{id}'] as const,
  getUserInfoForUserIds: ['post', '/users'] as const,
  getSAMRolesForAUser: ['get', '/users/roles/{appId}/{userId}'] as const,
  getUserSAMAndSRORolesOne: ['get', '/users/roles/{userId}'] as const,
  getUsersInSRORole: ['get', '/users/sro-roles/{roleId}'] as const,
  getSAMUsersInRole: ['get', '/users/{appId}/roles/{roleId}'] as const
} as const;
